import { StripeSubscriptionItemFragment } from 'src/graphql/generated/graphql'
import { formatCost } from 'src/helpers'
import styles from './currentPlanCardItem.module.scss'
import { Button } from '@sendoutcards/quantum-design-ui'

type CurrentPlanCardProps = {
  item: StripeSubscriptionItemFragment
  recurrence: 'month' | 'year'
  isManaging: boolean
  changeAction?: {
    title: string
    onClick: () => void
    isDisabled?: boolean
  }
  cancelAction?: {
    title: string
    onClick: () => void
    isDisabled?: boolean
  }
}

export const CurrentPlanCardItem: React.FC<CurrentPlanCardProps> = ({
  item,
  recurrence,
  isManaging,
  changeAction,
  cancelAction,
}) => {
  const hasLifetimeDiscount =
    item.discounts.findIndex(item => item.name === 'LifetimeACT') !== -1

  return (
    <div className={styles.item}>
      <div className={styles.verticalBar}></div>
      <span className={styles.name}>{item.name}</span>
      <div style={{ flexGrow: 1 }}></div>
      {hasLifetimeDiscount && <LifetimePill />}
      {item.undiscountedAmount !== item.amount && (
        <span className={`${styles.cost} ${styles.undiscounted}`}>
          {formatCost(item.undiscountedAmount)}
        </span>
      )}
      <div className={styles.cost}>
        <span className={styles.cost}>{formatCost(item.amount)}</span>
        <span className={styles.recurrence}>{`/${recurrence}`}</span>
      </div>

      {isManaging &&
        (item.isAddon
          ? cancelAction &&
            !hasLifetimeDiscount && (
              <Button
                title={cancelAction.title}
                size="xSmall"
                type="danger"
                onClick={() => cancelAction.onClick()}
                disabled={cancelAction.isDisabled}
                backgroundColorOverride="#FFF7F7"
                textColorOverride="#E7515D"
                // icon={{ name: 'delete', fill: '#E7515D' }}
              />
            )
          : changeAction && (
              <Button
                title={changeAction.title}
                size="xSmall"
                type="shadow"
                fontWeight="bold"
                outlined={false}
                onClick={changeAction.onClick}
                disabled={changeAction.isDisabled}
              />
            ))}
    </div>
  )
}

const LifetimePill: React.FC<{}> = () => {
  return <div className={styles.lifetimePill}>Lifetime</div>
}
